import { appConfig } from 'src/constants/appConfig';

import * as defaultRouter from './default';
import * as tauronRouter from './tauron';

const routers = appConfig?.tauron ? tauronRouter : defaultRouter;

export default routers;
